import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { filterMenuItems } from "../../Hooks/permissionsMiddleware";

const sidebarData = [
  {
    title: "Dashboard",
    icon: "ni ni-app",
    iconColor: "text-info",
    link: "/mobile-dashboard",
    // requiredPermissionID: 101 // Permission ID for Dashboard
  },

  {
    title: "Restaurant & Bar Sales",
    icon: "fa fa-coffee",
    iconColor: "text-success",
    link: "/beverage-sales",
    requiredPermissionID: 3006, // Permission ID for beverage sales section
    children: [
      {
        title: "Food & Drinks",
        link: "/beverage-sales/bar-sale",
        requiredPermissionID: 3006, // Permission ID for financial year
      },
    ],
  },
  {
    title: "Purchase History",
    icon: "ni ni-basket",
    iconColor: "text-success",
    requiredPermissionID: 2, // Permission ID for viewing sales history
    children: [
      {
        title: "Purchase History",
        link: "/sales-history",
        requiredPermissionID: 2,
      },
      // {
      //   title: "Check In",
      //   link: "/sales-history/check-in",
      //   requiredPermissionID: 2,
      // },
      // {
      //   title: "Check Out",
      //   link: "/sales-history/check-out",
      //   requiredPermissionID: 2,
      // },
    ],
  },
  {
    title: "Services",
    icon: "ni ni-collection",
    iconColor: "text-success",
    link: "/service",
    // requiredPermissionID: 21, // Permission ID for services
    children: [
      {
        title: "Category",
        link: "/service/category",
        requiredPermissionID: 21, // Permission ID for service category
      },
      {
        title: "Brands",
        link: "/service/brands",
        requiredPermissionID: 22, // Permission ID for managing brands
      },
      {
        title: "Services/Products Type",
        link: "/service/products-type",
        requiredPermissionID: 23, // Permission ID for products type
      },
      {
        title: "Manage services/products",
        link: "/service/products",
        requiredPermissionID: 24, // Permission ID for managing products
      },
      {
        title: "Inventory/Rate Chart",
        link: "/service/rate-chart",
        requiredPermissionID: 25, // Permission ID for rate chart
      },
    ],
  },
];

const MobileDropdown = ({ elem, onNavigate }) => {
  const location = useLocation();
  const [openDropdown, setDropdown] = useState(false);

  useEffect(() => {
    if (elem.children?.some((child) => location.pathname === child.link)) {
      setDropdown(true); // Open dropdown if visiting a child page
    }
  }, [location.pathname, elem.children]);

  const handleClick = (link) => {
    onNavigate(link);
  };

  return (
    <div className="mobile-nav-item">
      {!elem.children ? (
        <NavLink
          to={elem.link}
          onClick={() => handleClick(elem.link)}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "12px 16px",
            textDecoration: "none",
            color: "#333",
            borderBottom: "1px solid #f0f0f0",
            background:
              location.pathname === elem.link ? "#f8f9fa" : "transparent",
          }}
        >
          <div
            style={{
              marginRight: "12px",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className={`${elem.icon} ${elem.iconColor}`}
              style={{ fontSize: "16px" }}
            />
          </div>
          <span style={{ fontSize: "14px", fontWeight: "500" }}>
            {elem.title}
          </span>
        </NavLink>
      ) : (
        <>
          <div
            onClick={() => setDropdown(!openDropdown)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
              cursor: "pointer",
              borderBottom: "1px solid #f0f0f0",
              background: openDropdown ? "#f8f9fa" : "transparent",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  marginRight: "12px",
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className={`${elem.icon} ${elem.iconColor}`}
                  style={{ fontSize: "16px" }}
                />
              </div>
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                {elem.title}
              </span>
            </div>
            <i
              className={`fa fa-chevron-${openDropdown ? "up" : "down"}`}
              style={{ fontSize: "12px", color: "#666" }}
            />
          </div>
          {openDropdown && (
            <div style={{ background: "#f8f9fa" }}>
              {elem.children.map((child, i) => (
                <NavLink
                  key={i}
                  to={child.link}
                  onClick={() => handleClick(child.link)}
                  style={{
                    display: "block",
                    padding: "10px 16px 10px 52px",
                    textDecoration: "none",
                    color: "#555",
                    fontSize: "13px",
                    borderBottom: "1px solid #e9ecef",
                    background:
                      location.pathname === child.link
                        ? "#e9ecef"
                        : "transparent",
                  }}
                >
                  {child.title}
                </NavLink>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

const MobileSidebar = ({ isOpen, onClose }) => {
  const user = useSelector((state) => state.auth.user);
  const filteredSidebarData = filterMenuItems(sidebarData);

  const handleNavigate = (link) => {
    // Close modal after navigation
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={handleBackdropClick}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0, 0, 0, 0.5)",
          zIndex: 10000,
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "64px", // Below header
          left: 0,
          width: "280px",
          height: "calc(100vh - 64px)",
          background: "white",
          zIndex: 10001,
          overflowY: "auto",
          boxShadow: "2px 0 8px rgba(0, 0, 0, 0.15)",
          animation: "slideInLeft 0.3s ease",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px",
            borderBottom: "1px solid #e9ecef",
            background: "#f8f9fa",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h6 style={{ margin: 0, fontSize: "16px", fontWeight: "600" }}>
              Navigation
            </h6>
            <button
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                fontSize: "18px",
                cursor: "pointer",
                padding: "4px",
                color: "#676",
              }}
            >
              ×
            </button>
          </div>
        </div>

        {/* Navigation Items */}
        <div>
          {filteredSidebarData.map((elem, i) => (
            <MobileDropdown key={i} elem={elem} onNavigate={handleNavigate} />
          ))}
        </div>
      </div>

      <style>
        {`
          @keyframes slideInLeft {
            from {
              transform: translateX(-100%);
            }
            to {
              transform: translateX(0);
            }
          }
        `}
      </style>
    </>
  );
};

export default MobileSidebar;
